import {
  CHART_FIELD_ITEM_SELECTION_METHOD,
  CHART_GRAPH,
} from '@/entities/chart/model/constants';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import { COMBO_CHART_ERROR_MESSAGES } from '@/features/(charts)/chart-renderer/model/error-messages';
import { deleteObjectFields } from '@/utils/object';

import { isCalculationTypeEnabled, isViewTypeEnabled } from '../conditions';

// COMBO_CHART인 경우 series 검증
export const validateChartSeriesLength = (params: ChartBaseWithName) => {
  if (params.graph === CHART_GRAPH.COMBO_CHART) {
    if (!params.series || params.series.length < 2) {
      throw new Error(COMBO_CHART_ERROR_MESSAGES.SECONDARY_MEASURE_REQUIRED);
    }
  }
};

export const cleanSeriesOptions = (
  series: ChartSeriesDef,
  params: ChartBaseWithName | ChartState,
) => {
  const { type, graph } = params;
  const { measure, options } = series;
  if (!options) return series;

  let newOptions: ChartOptions = { ...options };

  // metric에 따른 view_type 분기처리
  if (!isViewTypeEnabled(graph, measure.metric)) {
    newOptions = deleteObjectFields(newOptions, [
      'view_type',
      'share_calculation_type',
      'share_cell_calculation_segment',
    ]);
  }

  // view_type에 따른 share_calculation_type, share_cell_calculation_segment 분기처리
  if (!isCalculationTypeEnabled(type, graph, newOptions.view_type)) {
    newOptions = deleteObjectFields(newOptions, [
      'share_calculation_type',
      'share_cell_calculation_segment',
    ]);
  }

  return {
    ...series,
    options: newOptions,
  };
};

export const getNormalizedHistorical = (
  historical: ChartHistorical,
  term: ChartTermDef,
): ChartHistorical => {
  return {
    value: historical.value ?? false,
    frequency: historical.value
      ? chartUtils.getFrequencyByTermUnit(term.unit)
      : null,
  };
};

export const getNormalizedSelectedField = (
  selectedField:
    | (Partial<ChartSelectedFieldItemDef> & {
        items?: StringNumberValue[];
      })
    | undefined,
  graph: CHART_GRAPH,
): ChartSelectedFieldItemDef | undefined => {
  // method가 설정되지 않은 경우 default 값
  if (graph === CHART_GRAPH.WORD_CLOUD && !selectedField?.method) {
    return {
      method: CHART_FIELD_ITEM_SELECTION_METHOD.TOP_50,
      items: selectedField?.items || [],
    };
  }

  if (!selectedField?.method) {
    return undefined;
  }

  return {
    method: selectedField.method,
    items: selectedField.items,
  };
};
